import { Container, Row, Col, Button } from "react-bootstrap";
import { submitForm } from "../utils/submitForm";

import "./Contact.css";

export default function Contact() {
  /**
   * @param {import('react').FormEvent<HTMLFormElement>} event
   */
  const sendEmail = (event) => {
    event.preventDefault();
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    submitForm(form).then(
      () => {
        alert("Email gönderildi!");
        form.reset();
      },
      () => {
        alert("Email gönderilirken hata oluştu!");
      }
    );
  };
  return (
    <Container className="contact-container">
      <Row>
        <Col style={{ marginTop: "20px" }}>
          <h1>Bize Ulaşın</h1>
          <p>
            Soru, öneri veya geri bildirimleriniz varsa, bize aşağıdaki formu{" "}
            <br></br> doldurarak ulaşabilirsiniz.
          </p>
          <form className="contact-form" onSubmit={sendEmail}>
            <input type="hidden" name="form_type" value="İletişim Formu" readOnly />
            <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" style={{ position: "absolute", left: "-9999px" }} />
            <label className="contact-label" htmlFor="nameFrom">
              Adınız:
            </label>
            <input
              className="contact-input"
              type="text"
              name="name_from"
              id="nameFrom"
            ></input>
            <label className="contact-label" htmlFor="emailFrom">
              E-posta Adresiniz:
            </label>
            <input
              className="contact-input"
              type="text"
              name="email_from"
              id="emailFrom"
            ></input>
            <label className="contact-label" htmlFor="phoneFrom">
              Telefon Numaranız:
            </label>
            <input
              className="contact-input"
              type="tel"
              name="phone_from"
              id="phoneFrom"
            ></input>
            <label className="contact-label" htmlFor="message">
              Mesajınız:
            </label>
            <textarea
              className="contact-input"
              name="message"
              id="message"
            ></textarea>
            <div style={{ textAlign: "center" }}>
              <Button className="contact-submit-button" type="submit">
                Gönder
              </Button>
            </div>
          </form>
        </Col>
      </Row>
    </Container>
  );
}
